import React from 'react';

// eslint-disable-next-line react/prop-types
const UnderStaffedSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { fill, ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="-2 -2 28 28"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      <rect width="24" height="24" x="0" y="0" rx="2" fill={fill} stroke="#404040" />

      {/* Question Mark */}
      <g transform="translate(12,12.5) scale(0.4)">
        <path
          d="M12 19c.828 0 1.5.672 1.5 1.5S12.828 22 12 22s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm0-17c3.314 0 6 2.686 6 6 0 2.165-.753 3.29-2.674 4.923C13.399 14.56 13 15.297 13 17h-2c0-2.474.787-3.695 3.031-5.601C15.548 10.11 16 9.434 16 8c0-2.21-1.79-4-4-4S8 5.79 8 8v1H6V8c0-3.314 2.686-6 6-6z"
          fill="#404040"
          stroke="#404040"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* User */}
      <path
        d="M4 21C4 17.134 7.13401 14 11 14M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
        strokeWidth="2"
        fill="none"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { UnderStaffedSVG };
